import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
  dataEvent : EventEmitter <any> = new EventEmitter<any>();
  navchange: EventEmitter<any> = new EventEmitter();
  constructor() { }

  setData(data:any){
    this.dataEvent.emit(data);
  }

  emitNavChangeEvent(data:any) {
    this.navchange.emit(data);
  }

  getNavChangeEmitter() {
    return this.navchange;
  }
}
